import {
  qualification,
  unconfirmedQualification,
} from '@seek/ca-myprofile-utils';
import gql from 'graphql-tag';

export const getUnconfirmedQualifications = gql`
  query GetUnconfirmedQualifications(
    $languageCode: LanguageCodeIso!
    $zone: Zone!
    $isUnifiedSite: Boolean!
  ) {
    viewer {
      _id
      unconfirmedQualifications: qualifications(
        status: unconfirmed
        languageCode: $languageCode
        zone: $zone
        isUnifiedSite: $isUnifiedSite
      ) {
        ...unconfirmedQualification
      }
    }
  }
  ${unconfirmedQualification}
`;

export const getConfirmedQualifications = gql`
  query GetConfirmedQualifications(
    $languageCode: LanguageCodeIso!
    $zone: Zone!
    $isUnifiedSite: Boolean!
  ) {
    viewer {
      _id
      confirmedQualifications: qualifications(
        includeVerified: true
        status: confirmed
        languageCode: $languageCode
        zone: $zone
        isUnifiedSite: $isUnifiedSite
        platform: WEB
        source: PROFILE
      ) {
        ...qualification
      }
    }
  }
  ${qualification}
`;

export const updateQualification = gql`
  mutation UpdateQualification(
    $qualification: UpdateQualificationInput!
    $languageCode: LanguageCodeIso!
    $zone: Zone!
    $isUnifiedSite: Boolean!
  ) {
    updateQualification(input: $qualification) {
      viewer {
        _id
        confirmedQualifications: qualifications(
          status: confirmed
          includeVerified: true
          languageCode: $languageCode
          zone: $zone
          isUnifiedSite: $isUnifiedSite
          platform: WEB
          source: PROFILE
        ) {
          ...qualification
        }
      }
    }
  }
  ${qualification}
`;

export const deleteQualification = gql`
  mutation DeleteQualification(
    $qualificationId: DeleteQualificationInput!
    $languageCode: LanguageCodeIso!
    $zone: Zone!
    $isUnifiedSite: Boolean!
  ) {
    deleteQualification(input: $qualificationId) {
      viewer {
        _id
        confirmedQualifications: qualifications(
          status: confirmed
          includeVerified: true
          languageCode: $languageCode
          zone: $zone
          isUnifiedSite: $isUnifiedSite
          platform: WEB
          source: PROFILE
        ) {
          ...qualification
        }
      }
    }
  }
  ${qualification}
`;

export const confirmQualification = gql`
  mutation ConfirmQualification(
    $qualification: ConfirmQualificationInput!
    $languageCode: LanguageCodeIso!
    $zone: Zone!
    $isUnifiedSite: Boolean!
  ) {
    confirmQualification(input: $qualification) {
      viewer {
        _id
        confirmedQualifications: qualifications(
          status: confirmed
          includeVerified: true
          languageCode: $languageCode
          zone: $zone
          isUnifiedSite: $isUnifiedSite
          platform: WEB
          source: PROFILE
        ) {
          ...qualification
        }
        unconfirmedQualifications: qualifications(
          status: unconfirmed
          languageCode: $languageCode
          zone: $zone
          isUnifiedSite: $isUnifiedSite
        ) {
          ...unconfirmedQualification
        }
      }
    }
  }
  ${qualification}
  ${unconfirmedQualification}
`;

export const rejectQualification = gql`
  mutation RejectQualification(
    $qualification: RejectUnconfirmedDataInput!
    $languageCode: LanguageCodeIso!
    $zone: Zone!
    $isUnifiedSite: Boolean!
  ) {
    rejectUnconfirmedData(input: $qualification) {
      viewer {
        _id
        unconfirmedQualifications: qualifications(
          status: unconfirmed
          languageCode: $languageCode
          zone: $zone
          isUnifiedSite: $isUnifiedSite
        ) {
          ...qualification
        }
      }
    }
  }
  ${qualification}
`;

export const updateVerifiedQualification = gql`
  mutation UpdateVerifiedQualification(
    $verifiedQualificationData: UpdateVerifiedQualificationInput!
    $languageCode: LanguageCodeIso!
    $zone: Zone!
    $isUnifiedSite: Boolean!
  ) {
    updateVerifiedQualification(input: $verifiedQualificationData) {
      viewer {
        _id
        confirmedQualifications: qualifications(
          status: confirmed
          includeVerified: true
          languageCode: $languageCode
          zone: $zone
          isUnifiedSite: $isUnifiedSite
          platform: WEB
          source: PROFILE
        ) {
          ...qualification
        }
      }
    }
  }
  ${qualification}
`;
